import round10Decimals from "./round10Decimals";


const CuentaMask = (value, truncate) => {
    const decimals = (truncate !== undefined && truncate !== null && truncate !== '' && truncate !== 0) ? truncate : 2;
    const factor = 10 ** decimals;
    const rounded = Math.round(round10Decimals(value) * factor) / factor;
    let numberRound = rounded.toFixed(decimals)
    let arrayString = numberRound.toString().split('.')
    let primero = arrayString[0].replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
    let segundo = arrayString[1]
    if(segundo){
      return `$ ${primero}.${segundo}`
    }else{
      return `$ ${primero}`
    }
  };
  
  export default CuentaMask;